import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { ServiceCallEquipmentSummaryService } from './service-call-equipment-summary.service';

import { DialogHelper, ExceptionHelper } from './../../../../helper';
import * as $ from 'jquery';

@Component({
  selector: 'app-service-call-equipment-summary',
  templateUrl: './service-call-equipment-summary.component.html'
})
export class ServiceCallEquipmentSummaryComponent implements OnInit {

  id = '';
  equipments: any[];
  dataTable: any;

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private serviceCallEquipmentSummaryService: ServiceCallEquipmentSummaryService,
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit() {
    this.getEquipmentDetail();
  }

  getEquipmentDetail() {
    this.serviceCallEquipmentSummaryService
      .getSummary(this.id)
      .subscribe(
        data => {
          if ($.fn.dataTable.isDataTable('#equipmentDataTables')) { $('#equipmentDataTables').DataTable().destroy(); }
          this.equipments = data.equipmentListModel;
          this.chRef.detectChanges();

          const table: any = $('#equipmentDataTables');
          this.dataTable = table.DataTable();
        },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
        }
      );
  }

  errorClose() {
    this.router.navigate(['/home/service']);
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-detail/service-call-equipment-summary.component.ts